import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { optionCarousel } from 'src/app/utility/carousel.config';
import { CarouselHeroBarComponent } from '../carousel-hero-bar/carousel-hero-bar.component';
declare var $: any;

@Component({
  selector: 'app-sample-carousel',
  templateUrl: './sample-carousel.component.html',
  styleUrls: ['./sample-carousel.component.scss']
})
export class SampleCarouselComponent implements OnInit {

  @Input() block: any;
  @Input() setBlockItemsCarousel: any[] = [];
  @ViewChild('carousel') carousel?: CarouselComponent;
  @ViewChild('carouselBar') carouselBar?: CarouselHeroBarComponent;
  public slideId :string = ""

  public customOptionsOwl: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    autoWidth: true,
    nav: true
  };

  constructor(private helpersService: HelpersService) { }

  ngOnInit(): void {
    this.customOptionsOwl = {
      ...this.customOptionsOwl,
      ...optionCarousel(this.block.bundle)
    }
    this.slideId = "1"
  }

  getData(evt: any) {
    if (this.helpersService.isBrowser) {
      const attributes = [
        { name: "role", value: "button" },
        { name: "aria-label", value: "owl" },
        { name: "tabindex", value: "0" },
      ];
      setTimeout(() => {
        this.helpersService.setDataAttributes(".owl-dot", attributes);
        this.helpersService.setDataAttributes(".owl-next", attributes);
        this.helpersService.setDataAttributes(".owl-prev", attributes);
      }, 50)
    }
  }

  getPassedData(data: SlidesOutputData) {
    if(data.slides?.length){
      this.slideId = data.slides[0].id
    }
    if(this.carouselBar){
      this.carouselBar.moveTo(this.slideId)
    }
  }

  public selectSlide(id:string){
    if(this.carousel){
      this.carousel.to(id)
    }
  }


}
